import API from "../helpers/APIHelper";
import { ENDPOINTS } from "../../API/apiConstants";

export type ShareChannel = "copy_link" | "whatsapp" | "email" | "native";
export type ShareSurface = "property_detail" | "stay_card";

interface TrackShareArgs {
  propertyId: number | string;
  channel: ShareChannel;
  surface: ShareSurface;
}

export const trackShare = ({ propertyId, channel, surface }: TrackShareArgs) => {
  API.post(ENDPOINTS.POST_SHARE(propertyId), {
    share: { channel, surface },
  }).catch(() => {
    // fire and forget — tracking must never interrupt the share
  });

  // Mirror to GA4 — gives you the funnel view (did sharers convert?)
  if (typeof (window as any).gtag === "function") {
    (window as any).gtag("event", "share", {
      method: channel,
      content_type: "property",
      item_id: String(propertyId),
      surface,
    });
  }
};